export const PROHIBITED_ITEMS_REPORT_GENERATE_REPORT =
  'PROHIBITED_ITEMS_REPORT_GENERATE_REPORT';
export const PROHIBITED_ITEMS_REPORT_CLEAR_REPORT =
  'PROHIBITED_ITEMS_REPORT_CLEAR_REPORT';
export const PROHIBITED_ITEMS_REPORT_REPORT_LOADING =
  'PROHIBITED_ITEMS_REPORT_REPORT_LOADING';
export const PROHIBITED_ITEMS_REPORT_REPORT_ERROR =
  'PROHIBITED_ITEMS_REPORT_REPORT_ERROR';



// WEBPACK FOOTER //
// ./src/pages/prohibiteditems/state/report/types.js